import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import openGraphImage from '../assets/img/open-graph.png'

import '../css/main.less'

class BlogIndex extends React.Component {
  render () {
    const url = process.env.NODE_ENV === 'production' ? config.domain : "http://localhost:8000";
    return (
      <div className="page home-page parallax-group has-signup">
        <Helmet
            title={config.title}
            meta={[
                {"name": "google-site-verification", "content": "_1zknlZ9Yp6taSvpTdc2j9tDfF9aqTr7fWPzkdhyeQQ"},
                {"name": "description", "content": config.description},
                {"property": "og:type", "content": "article"},
                {"property": "og:locale", "content": "en_US"},
                {"property": "og:title", "content": config.title},
                {"property": "og:description", "content": config.description},
                {"property": "og:url", "content": url},
                {"property": "og:site_name", "content": config.title},
                {"property": "og:image", "content": url + "/" + openGraphImage},
                {"property": "og:image:width", "content": "1200"},
                {"property": "og:image:height", "content": "630"},
                {"property": "twitter:card", "content": "summary"},
                {"property": "twitter:creator", "content": "@scrimmageqa"},
                {"property": "twitter:site", "content": "@scrimmageqa"},
              ]}/>
        <section className="hero">
          <div className="container">
            <h1>Ship quality software faster</h1>
            <h4 className="tagline">ScrimmageQA automates the coordination and reporting of manual testing.</h4>
            <div className="hero-graphic">
              <div className="hero-graphic-fade">
                <div className="testplanmd"/>
                <div className="arrow1"/>
                <div className="scrimmage"/>
                <div className="arrow2"/>
                <div className="slack-window slack-window3">
                  <div className="slack-messages-mask">
                    <div className="slack-button button-green"/>
                    <div className="slack-button button-red"/>
                    <div className="slack-messages"/>
                  </div>
                </div>
                <div className="slack-window slack-window2">
                  <div className="slack-messages-mask">
                    <div className="slack-button button-green"/>
                    <div className="slack-button button-red"/>
                    <div className="slack-messages"/>
                  </div>
                </div>
                <div className="slack-window slack-window1">
                  <div className="slack-messages-mask">
                    <div className="slack-button button-green"/>
                    <div className="slack-button button-red"/>
                    <div className="slack-messages"/>
                  </div>
                </div>
                <div className="arrow3"/>
                <div className="browser">
                  <div className="scenarios-mask">
                    <div className="scenarios"/>
                    <div className="scenarios-fader"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

BlogIndex.propTypes = {
  route: React.PropTypes.object,
}

export default BlogIndex



// WEBPACK FOOTER //
// ./index.js